import { CheckCircle2, HelpCircle, Loader2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useTourPrepStore } from '../../features/training/tourPrepStore';
import { useDevStore } from '../../store/useDevStore';
import './help.css';

export interface HelpButtonProps {
  className?: string;
  style?: React.CSSProperties;
  /** Abre o painel de ajuda / tour (preferido). */
  onOpenHelp?: () => void;
}

export function HelpButton({ className, style, onOpenHelp }: HelpButtonProps = {}) {
  const { settings } = useDevStore();
  const path = useLocation().pathname;
  const rawStatus = useTourPrepStore((s) => s.byPath[path]?.status || 'idle');
  const status = settings.showTour ? rawStatus : 'idle';

  const title =
    status === 'preparing'
      ? 'Preparando tour desta página…'
      : status === 'ready'
        ? 'Tour pronto — abra a ajuda para iniciar'
        : 'Ajuda';

  return (
    <button
      type="button"
      className={`${className || 'ac-header-help-btn text-foreground hover:bg-muted'} ac-help-btn--${status}`}
      onClick={() => onOpenHelp?.()}
      title={title}
      aria-label={title}
      style={
        style || {
          background: 'none',
          border: '1px solid hsl(var(--border))',
          borderRadius: 8,
          width: 34,
          height: 34,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s',
          padding: 0,
          position: 'relative',
        }
      }
    >
      {status === 'preparing' ? (
        <Loader2 size={16} className="ac-help-spin" />
      ) : status === 'ready' ? (
        <CheckCircle2 size={16} className="ac-help-ready-icon" />
      ) : (
        <HelpCircle size={16} />
      )}
      {status === 'ready' && <span className="ac-help-ready-dot" aria-hidden />}
    </button>
  );
}
